import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mode, QuestionType } from '../../app.constant';
import { Router } from '@angular/router';
import { ShareService } from '../../service/share.service';

@Component({
  selector: 'app-b-checkbox',
  templateUrl: './b-checkbox.component.html',
  styleUrls: ['./b-checkbox.component.css']
})
export class BCheckboxComponent implements OnInit {

  //Component間の共有プロパティ
  @Input() question: any;
  @Input() t_result_list: any[];
  @Input() mode: number;
  @Input() hiddenflg: boolean;
  @Output() t_result_listChange = new EventEmitter();

  //textboxに関するMode制御用
  inputFlag :any;
  includeFlag :any;
  MODE:any = Mode;
  Q_TYPE:any = QuestionType;
  dis:number;

  constructor(
    private router: Router,
    private shareService: ShareService,
  ) { }

  ngOnInit() {
    //すべての回答を見に行っている。無駄が多いかも
    var answerList = this.question.m_answer_list;
    for (var i in answerList) {
      this.isCheck(answerList[i]);
    }
    //回答値が存在する場合の回答の制御。特殊健診の対象者情報のみに使用。
    var checkanswer = answerList.filter(
      item => 
      item.checked == true && item.code != null
    );
    if(checkanswer.length==0){
      this.dis = 0;
    }else{
      var spcheck = checkanswer.filter(
        item => 
        item.code != '$$$'
      );
      if(spcheck.length==0){
        this.dis = 999;
      }else{
        this.dis = spcheck.length;
      }
    }
    //渡されてきたQuestionからプロパティに値を入れる
    this.inputFlag = (this.question.m_question_last_text_input_flg == 1);
    this.includeFlag = (this.question.m_question_last_text_input_include_flg == 1);
  }

  /**
   * ngOnInitからのみ実行
   * チェックボックスの初期チェックを付ける
   * @param answer m_answerの1レコード
   */
  isCheck(answer) {
    //プロパティを一度falseで初期化
    answer.checked = false;

    var checkedList = this.t_result_list["t_result_id_list"];
    //回答IDから配列内にそのIDが存在するか検索
    var index = checkedList.indexOf(answer.m_answer_id);
    if(index > -1) answer.checked = true;
  }

  /**
   * チェックボックス変更イベント
   * @param answer 
   */
  changeCheck(answer) {
    var checkedList = this.t_result_list["t_result_id_list"];
    if (answer.checked) {
      //チェックがつけられた
      checkedList.push(answer.m_answer_id);
      if(answer.code=='$$$'){
        this.dis = 999;
      }else if(answer.code!=null){
        this.dis = this.dis+1;
      }else{
        //
      }
    } else {
      //チェックが外された
      var index = checkedList.indexOf(answer.m_answer_id);
      checkedList.splice(index, 1);
      if(answer.code=='$$$'){
        this.dis = 0;
      }else if(answer.code!=null){
        this.dis = this.dis-1;
      }else{
        //
      }
    }
    return this.dis; 
  }

  goRegister(question: any): void {
    let categoryInfo = this.shareService.getCategoryInfoShare();
    this.router.navigate(["/question-register/" + categoryInfo["m_question_category_id"] + "/" + question["m_question_id"] + "/" + categoryInfo["m_language_id"] + "/" + question["result_option"]]);
  }
}



// WEBPACK FOOTER //
// ./src/app/parts/b-checkbox/b-checkbox.component.ts